import type { StepMap, StepSource } from "@/Modules/Models/Domain/OnBoarding";
import {
  AnswersIds,
  ChoicesName,
  StepId,
  TherapyType,
  MinorAgeAnswers,
  YesOrNoAnswer,
  AREA_EXTRA_THERAPIST_KNOW,
  SUBAREA_NAME_THERAPIST_KNOWN,
  CUSTOM_B2B_USER,
  B2B_USER,
  WELLHUB_USER,
  MIN_AGE,
  MAX_AGE_UNDER_18,
  LIMIT_AGE,
  AREA_NAME_COACHING,
  EMPTY_AREA,
} from "@/Modules/Models/Domain/OnBoarding";

// @ts-expect-error THER-6617
export const stepSource: StepSource = {
  [StepId.USERNAME]: {
    title: "onboarding.step.username.title",
    highlightedTitle: "onboarding.step.username.title_highlighted",
    infoField: ["onboarding.step.username.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.USERNAME,
        value: "",
        mandatory: true,
        type: "text",
        name: "TcInput",
        placeholder: "onboarding.step.username.name",
        maxCharacters: 100,
      },
    ],
  },
  [StepId.THERAPY_TYPE]: {
    title: "onboarding.step.therapy_type.title",
    highlightedTitle: "onboarding.step.therapy_type.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPY_TYPE,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.THERAPY_TYPES,
      },
    ],
  },
  [StepId.THERAPY_LANGUAGE]: {
    highlightedTitle: "onboarding.step.therapy_language.title",
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPY_LANGUAGE,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.ADDITIONAL_LANGUAGES,
      },
    ],
  },
  [StepId.FIRST_TIME]: {
    title: "onboarding.step.first_time.title",
    highlightedTitle: "onboarding.step.first_time.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.FIRST_TIME,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        options: [
          {
            title: "onboarding.step.first_time.option1.title",
            value: YesOrNoAnswer.YES,
          },
          {
            title: "onboarding.step.first_time.option2.title",
            value: YesOrNoAnswer.NO,
          },
        ],
      },
    ],
  },
  [StepId.USER_AGE]: {
    title: "onboarding.step.user_age.title",
    highlightedTitle: "onboarding.step.user_age.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.USER_AGE,
        value: "",
        mandatory: true,
        name: "TcInput",
        type: "number",
        placeholder: "onboarding.step.user_age.placeholder",
        min: MIN_AGE,
        max: LIMIT_AGE,
      },
    ],
  },
  [StepId.USER_AGE_MINOR]: {
    title: "onboarding.step.user_age.title",
    highlightedTitle: "onboarding.step.user_age.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.USER_AGE,
        value: "",
        mandatory: true,
        name: "TcInput",
        type: "number",
        placeholder: "onboarding.step.user_age.placeholder",
        max: MAX_AGE_UNDER_18,
      },
    ],
  },
  [StepId.USER_GENDER]: {
    highlightedTitle: "onboarding.step.user_gender.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.user_gender.info"],
    components: [
      {
        id: AnswersIds.USER_GENDER,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDERS,
      },
    ],
  },
  [StepId.USER_COUPLE_AGE]: {
    title: "onboarding.step.user_age.title",
    highlightedTitle: "onboarding.step.user_age.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.USER_AGE,
        value: "",
        mandatory: true,
        name: "TcInput",
        type: "number",
        placeholder: "onboarding.step.user_age.placeholder",
        min: MIN_AGE,
        max: LIMIT_AGE,
      },
    ],
  },
  [StepId.USER_COUPLE_GENDER]: {
    highlightedTitle: "onboarding.step.user_gender.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.user_gender.info"],
    components: [
      {
        id: AnswersIds.USER_GENDER,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDERS,
      },
    ],
  },
  [StepId.COUPLE_AGE]: {
    highlightedTitle: "onboarding.step.couple_age.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.COUPLE_AGE,
        value: "",
        mandatory: true,
        name: "TcInput",
        type: "number",
        placeholder: "onboarding.step.user_age.placeholder",
        min: MIN_AGE,
        max: LIMIT_AGE,
      },
    ],
  },
  [StepId.COUPLE_GENDER]: {
    title: "onboarding.step.couple_gender.title",
    actionButton: true,
    infoField: ["onboarding.step.user_gender.info"],
    components: [
      {
        id: AnswersIds.COUPLE_GENDER,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDERS,
      },
    ],
  },
  [StepId.MAIN_AREA]: {
    title: "onboarding.step.main_area.title",
    highlightedTitle: "onboarding.step.main_area.title_highlighted",
    subtitle: "onboarding.step.main_area.subtitle",
    infoField: ["onboarding.step.main_area.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.MAIN_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.MAIN_AREA,
        filterChoices: {
          param: "name",
          value: AREA_NAME_COACHING,
          equal: false,
        },
      },
    ],
  },
  [StepId.COACHING_SUBAREA]: {
    title: "onboarding.step.main_area.title",
    highlightedTitle: "onboarding.step.main_area.subtitle",
    actionButton: true,
    components: [
      {
        id: AnswersIds.SUB_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.SUB_AREA,
      },
    ],
  },
  [StepId.COUPLE_SUBAREA]: {
    title: "onboarding.step.couple_subarea.title",
    highlightedTitle: "onboarding.step.main_area.subtitle",
    actionButton: true,
    components: [
      {
        id: AnswersIds.SUB_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.COUPLE_SUBAREA,
        filterChoices: {
          param: "isCouple",
          value: true,
        },
      },
    ],
  },
  [StepId.SUB_AREA]: {
    title: "onboarding.step.subarea.title",
    highlightedTitle: "onboarding.step.subarea.title_highlighted",
    actionButton: true,
    infoSpecialMainArea: "depression",
    components: [
      {
        id: AnswersIds.SUB_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.SUB_AREA,
        filterChoices: {
          param: "isCouple",
          value: false,
        },
      },
    ],
  },
  [StepId.THERAPIST_NAME]: {
    highlightedTitle: "onboarding.step.therapist_name.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_NAME,
        value: "",
        mandatory: true,
        type: "text",
        name: "TcInput",
        placeholder: "onboarding.step.therapist_name.placeholder",
        maxCharacters: 100,
        minCharacters: 5,
      },
    ],
  },
  [StepId.TIME_AFFECTED]: {
    highlightedTitle: "onboarding.step.time_affected.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.TIME_AFFECTED,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        options: [
          {
            title: "onboarding.step.time_affected.option1.title",
            value: "days",
          },
          {
            title: "onboarding.step.time_affected.option2.title",
            value: "weeks",
          },
          {
            title: "onboarding.step.time_affected.option3.title",
            value: "month",
          },
          {
            title: "onboarding.step.time_affected.option4.title",
            value: "months",
          },
          {
            title: "onboarding.step.time_affected.option5.title",
            value: "years",
          },
        ],
      },
    ],
  },
  [StepId.TELL_ME_MORE]: {
    title: "onboarding.step.tell_me_more.title",
    highlightedTitle: "onboarding.step.tell_me_more.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.tell_me_more.info"],
    components: [
      {
        id: AnswersIds.TELL_ME_MORE,
        value: "",
        mandatory: false,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.tell_me_more.placeholder",
        label: "onboarding.step.tell_me_more.label",
      },
    ],
  },
  [StepId.THERAPIST_GENDER_PREFERENCES]: {
    title: "onboarding.step.therapist_gender_preferences.title",
    highlightedTitle: "onboarding.step.therapist_gender_preferences.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.therapist_gender_preferences.info"],
    components: [
      {
        id: AnswersIds.THERAPIST_GENDER_PREFERENCES,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDER_PREFERENCES,
      },
    ],
  },
  [StepId.THERAPIST_AVAILABILITIES]: {
    title: "onboarding.step.therapist_availabilities.title",
    highlightedTitle: "onboarding.step.therapist_availabilities.title_highlighted",
    subtitle: "onboarding.step.therapist_availabilities.subtitle",
    infoField: ["onboarding.step.therapist_availabilities.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_AVAILABILITY,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.AVAILABILITIES,
      },
    ],
  },
};

// @ts-expect-error THER-6617
export const stepMap: StepMap = {
  [StepId.WELCOME]: [
    {
      id: "*",
      nextStep: StepId.USERNAME,
    },
  ],
  [StepId.WELCOME_B2B]: [
    {
      id: "*",
      nextStep: StepId.USERNAME,
    },
  ],
  [StepId.USERNAME]: [
    {
      id: WELLHUB_USER,
      nextStep: StepId.THERAPY_TYPE,
    },
    {
      id: "*",
      nextStep: StepId.PRIVACY_POLICY,
    },
  ],
  [StepId.PRIVACY_POLICY]: [
    {
      id: "*",
      nextStep: StepId.THERAPY_LANGUAGE,
    },
  ],
  [StepId.THERAPY_LANGUAGE]: [
    {
      id: "*",
      nextStep: StepId.THERAPY_TYPE,
    },
  ],
  [StepId.THERAPY_TYPE]: [
    {
      id: TherapyType.COACHING,
      nextStep: StepId.USER_AGE,
    },
    {
      id: B2B_USER,
      nextStep: StepId.FIRST_TIME,
    },
    {
      id: "*",
      nextStep: StepId.FIRST_TIME,
    },
  ],
  [StepId.FIRST_TIME]: [
    {
      id: TherapyType.SINGLE,
      nextStep: StepId.USER_AGE,
    },
    {
      id: TherapyType.COUPLE,
      nextStep: StepId.USER_COUPLE_AGE,
    },
    {
      id: TherapyType.MINOR,
      nextStep: StepId.USER_AGE_MINOR,
    },
  ],
  [StepId.USER_COUPLE_AGE]: [
    {
      id: "*",
      nextStep: StepId.USER_COUPLE_GENDER,
    },
  ],
  [StepId.USER_COUPLE_GENDER]: [
    {
      id: "*",
      nextStep: StepId.COUPLE_AGE,
    },
  ],
  [StepId.COUPLE_AGE]: [
    {
      id: "*",
      nextStep: StepId.COUPLE_GENDER,
    },
  ],
  [StepId.COUPLE_GENDER]: [
    {
      id: "*",
      nextStep: StepId.COUPLE_SUBAREA,
    },
  ],
  [StepId.COUPLE_SUBAREA]: [
    {
      id: SUBAREA_NAME_THERAPIST_KNOWN,
      nextStep: StepId.THERAPIST_NAME,
    },
    {
      id: EMPTY_AREA,
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
    {
      id: "*",
      nextStep: StepId.TIME_AFFECTED,
    },
  ],
  [StepId.USER_AGE]: [
    {
      id: "*",
      nextStep: StepId.USER_GENDER,
    },
  ],
  [StepId.USER_AGE_MINOR]: [
    {
      id: MinorAgeAnswers.ADVICE,
      nextStep: StepId.USER_AGE_MINOR_ADVICE,
    },
    {
      id: MinorAgeAnswers.REJECT,
      nextStep: StepId.USER_AGE_MINOR_REJECT,
    },
  ],
  [StepId.USER_AGE_MINOR_ADVICE]: [
    {
      id: "*",
      nextStep: StepId.USER_GENDER,
    },
  ],
  [StepId.USER_AGE_MINOR_REJECT]: [
    {
      id: "*",
      nextStep: StepId.USER_AGE_MINOR_REJECT,
    },
  ],
  [StepId.USER_GENDER]: [
    {
      id: TherapyType.COACHING,
      nextStep: StepId.COACHING_SUBAREA,
    },
    {
      id: "*",
      nextStep: StepId.MAIN_AREA,
    },
  ],
  [StepId.MAIN_AREA]: [
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.THERAPIST_NAME,
    },
    {
      id: EMPTY_AREA,
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
    {
      id: TherapyType.COACHING,
      nextStep: StepId.TELL_ME_MORE,
    },
    {
      id: "*",
      nextStep: StepId.SUB_AREA,
    },
  ],
  [StepId.SUB_AREA]: [
    {
      id: "*",
      nextStep: StepId.TIME_AFFECTED,
    },
  ],
  [StepId.COACHING_SUBAREA]: [
    {
      id: EMPTY_AREA,
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.THERAPIST_NAME]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.TIME_AFFECTED]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.TELL_ME_MORE]: [
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.REGISTER,
    },
    {
      id: "*",
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
  ],
  [StepId.THERAPIST_GENDER_PREFERENCES]: [
    {
      id: "*",
      nextStep: StepId.THERAPIST_AVAILABILITIES,
    },
  ],
  [StepId.THERAPIST_AVAILABILITIES]: [
    {
      id: "*",
      nextStep: StepId.REGISTER,
    },
  ],
  [StepId.REGISTER]: [
    {
      id: "*",
      nextStep: StepId.EMAIL_VERIFICATION,
    },
  ],
  [StepId.EMAIL_VERIFICATION]: [
    {
      id: CUSTOM_B2B_USER,
      nextStep: StepId.REGISTER_USER_B2B_CUSTOM,
    },
    {
      id: "*",
      nextStep: StepId.CHECKOUT,
    },
  ],
  [StepId.REGISTER_USER_B2B_CUSTOM]: [
    {
      id: "*",
      nextStep: StepId.CHECKOUT,
    },
  ],
  [StepId.CHECKOUT]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.NICE_CHOICE_MY_FRIEND]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
};
